import { Provider, inject } from '@angular/core';
import { REALTIME_TOKEN_PROVIDER, RealtimeTokenProvider } from '@zayan-erp/realtime';
import { UserAuthenticationService } from '@zayan-erp/administration';

/**
 * Adapts this application's auth service to the realtime library's token contract.
 *
 * The adapter lives here, in the app, so the library imports nothing from the rest of the
 * workspace and the auth service is read without being modified. Swapping auth later changes
 * this one file.
 */
export const realtimeTokenProvider: Provider = {
  provide: REALTIME_TOKEN_PROVIDER,
  useFactory: (): RealtimeTokenProvider => {
    const auth = inject(UserAuthenticationService);

    return {
      // Read on every negotiate and reconnect, never cached: a token captured once would be
      // stale by the time the connection needs to come back.
      //
      // LocalStorageManagerService.getTokenFromStorage() returns the literal string '{}' when
      // there is no token, not null - so that placeholder has to be filtered out here or the
      // connection's "no token, don't attempt" guard never fires.
      getToken: () => {
        const token = auth.getToken();
        return token && token !== '{}' ? token : null;
      }
    };
  }
};
